module.exports = __webpack_public_path__ + "0f924708aed667041db1ecf2573a6fcf.png";